import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";

const Icon = styled.i`
  color: ${props => colors[props.color]};
  font-size: ${props => props.fontSize};
  padding: ${props => props.desktopPadding};

  @media screen and (max-width: 660px) {
    padding: ${props => props.mobilePadding};
  }
`;

Icon.displayName = "Icon";

export default Icon;
